export default __webpack_public_path__ + "static/media/offerImg.5832db01.webp";